import styled from "styled-components";
import pokeball from "../../img/masterball.png";

export const StyledStartButton = styled.button`
  box-sizing: border-box;
  display: flex;
  align-item: center;
  margin: 0 0 20px 100px #fff;
  padding: 20px;
  min-height: 30px;
  width: 100%;
  border-radius: 20px;
  color: red;
  background: #333;
  font-size: 1rem;
  outline: none;
  cursor: pointer;

  // border: 5px solid #200a3e;
  transform: scale(0.8);
  font-family: 'Pixel', sans-serif;

  border: 2px solid #2c2c2c;
  border-radius: 20px;
  background: #1c1c1c;
  color: #fff;
  font-size: 1.5rem;
  font-family: 'Pixel', sans-serif;
  outline: none;
  cursor: pointer;
  padding: 15px 30px;
  margin: 20px auto;
  display: block;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.4);

`;
